import { Chip } from '@mui/material';

import { getColorForPreset } from '@/ui/utils/get-color-for-preset';

export function PresetToColor() {
  return (
    <div>
      {[0, 1, 2, 3, 4, 5].map((index) => (
        <p key={index}>
          Preset {index + 1} : <PresetSwatch color={getColorForPreset(index)} />
        </p>
      ))}
    </div>
  );
}

function PresetSwatch({ color }: { color: string }) {
  return (
    <Chip
      label={'Config salle normal'}
      size="small"
      sx={{ bgcolor: color, fontWeight: 600, color: 'black' }}
    />
  );
}
